import React, { useEffect, useRef } from "react";

const SCRIPT_ID = "cf-turnstile-script";
const SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY || "";

const loadScript = () =>
  new Promise((resolve, reject) => {
    if (window.turnstile) {
      resolve();
      return;
    }
    const existing = document.getElementById(SCRIPT_ID);
    if (existing) {
      existing.addEventListener("load", () => resolve(), { once: true });
      existing.addEventListener("error", () => reject(new Error("Turnstile yüklenemedi")), { once: true });
      return;
    }
    const script = document.createElement("script");
    script.id = SCRIPT_ID;
    script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Turnstile yüklenemedi"));
    document.head.appendChild(script);
  });

const TurnstileWidget = ({ onVerify, onExpire, onError, resetKey = 0 }) => {
  const hostRef = useRef(null);
  const widgetRef = useRef(null);
  const onVerifyRef = useRef(onVerify);
  const onExpireRef = useRef(onExpire);
  const onErrorRef = useRef(onError);

  onVerifyRef.current = onVerify;
  onExpireRef.current = onExpire;
  onErrorRef.current = onError;

  useEffect(() => {
    let active = true;

    const mount = async () => {
      try {
        await loadScript();
        if (!active || !hostRef.current || !window.turnstile) return;
        if (widgetRef.current != null) {
          window.turnstile.remove(widgetRef.current);
          widgetRef.current = null;
        }
        widgetRef.current = window.turnstile.render(hostRef.current, {
          sitekey: SITE_KEY,
          theme: "dark",
          callback: (token) => onVerifyRef.current?.(token),
          "expired-callback": () => onExpireRef.current?.(),
          "error-callback": () => onErrorRef.current?.(),
        });
      } catch {
        onErrorRef.current?.();
      }
    };

    mount();
    return () => {
      active = false;
      if (widgetRef.current != null && window.turnstile) {
        window.turnstile.remove(widgetRef.current);
        widgetRef.current = null;
      }
    };
  }, [resetKey]);

  return <div className="turnstile-wrap" ref={hostRef} />;
};

export default TurnstileWidget;
